const mobileMoneyMapToApi = (paymentMethod) => {
  return {
    full_name: paymentMethod.accountName,
    phone_number: paymentMethod.phoneNumber
  }
}

const bankAccountMapToApi = (paymentMethod) => {
  return {
    bank: paymentMethod.bankId,
    account_name: paymentMethod.accountName,
    account_number: paymentMethod.accountNumber
  }
}

const paymentMethodsMap = {
  mobileMoneyAccount: {
    map: mobileMoneyMapToApi
  },
  bankAccount: {
    map: bankAccountMapToApi
  }
}

const paymentMethodMapToApi = (paymentMethod) => {
  return paymentMethodsMap[paymentMethod.type].map(paymentMethod)
}

export {
  paymentMethodMapToApi
}
